export const ORDER_VIEW_OPTIONS = [
  { value: 'priority', label: 'Priority View' },
  { value: 'classic', label: 'Classic View' },
] as const;

export type OrderViewPreference = typeof ORDER_VIEW_OPTIONS[number]['value'];


